import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { query, changeMode, changeCurrentPage, setOrder } from '../ActionsBrafab/CreditOrder.action';
import CreditOrderHistoryList from '../ComponentsBrafab/CreditOrderHistoryList';
import CreditOrderHistoryB2BDetail from '../ComponentsBrafab/CreditOrderHistoryB2BDetail';
import Pagination from '../Components/Pagination';
import { calculatePager } from '../Services/Pagination.service';
import { translate } from '../Services/translation';
import { PaginationOptions, ViewMode } from '../constants';
import { isEmpty } from 'lodash-es';

const CreditOrderListContainer = () => {
    const { mode, totalCount, currentPage, showOnlyMyOrders, errors } = useSelector(
        (state) => state.myPage.creditOrders
    );

    const { isBusinessCustomer } = useSelector((state) => state.myPage);
    const [currentShowMyOrder, setCurrentShowMyOrder] = useState(showOnlyMyOrders || false);
    const [pager, setPager] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(query(currentPage, currentShowMyOrder));
    }, [dispatch, currentPage, currentShowMyOrder]);

    useEffect(() => {
        setPager(calculatePager(totalCount, currentPage));
    }, [totalCount, currentPage]);

    const showDetail = useCallback(
        (order) => {
            dispatch(setOrder(order));
            dispatch(changeMode(ViewMode.Detail));
        },
        [dispatch]
    );

    const showList = useCallback(() => {
        dispatch(setOrder({}));
        dispatch(changeMode(ViewMode.List));
    }, [dispatch]);

    const changeShowMyOrder = useCallback((checked) => {
        setCurrentShowMyOrder(checked);
    }, []);

    const changePageIndex = useCallback(
        (index) => {
            if (index !== currentPage) {
                dispatch(changeCurrentPage(index));
            }
        },
        [currentPage, dispatch]
    );

    return (
        <Fragment>
            <h2>{translate('code.mypage.creditorder.listtitle')}</h2>

            {errors && !isEmpty(errors) && (
                <Fragment>
                    {Object.keys(errors).map((key, i) => (
                        <div key={i} className="form__validator--error">
                            {translate(errors[key])}
                        </div>
                    ))}
                </Fragment>
            )}
            {mode !== ViewMode.List && (
                <Fragment>
                    <CreditOrderHistoryB2BDetail
                        onDismiss={showList}
                    />
                </Fragment>
            )}
            {mode === ViewMode.List && (
                <Fragment>
                    <p>
                        <b>{translate('code.mypage.creditorder.subtitle')}</b>
                    </p>
                    <CreditOrderHistoryList
                        onShowDetail={showDetail}
                        isBusinessCustomer={isBusinessCustomer}
                    />
                    <Pagination model={pager} onChange={changePageIndex} />
                </Fragment>
            )}
        </Fragment>
    );
};

export default CreditOrderListContainer;